import {Show} from 'platform/foundation';

import {AdvertisingPlatformCodeEnum} from '@dms/api/shared';
import {featureFlags} from '@dms/feature-flags';

import {PlatformPhotoSettings} from './components/PlatformPhotoSettings';

export function PlatformSettingsAudiPl() {
  return (
    <Show whenFeatureEnabled={featureFlags.ADVERTISEMENT_GENERAL_SETTINGS}>
      <PlatformPhotoSettings platformCode={AdvertisingPlatformCodeEnum.AUDI_PL} />
    </Show>
  );
}
